export const WIDGETS_UPLOAD_SUCCESS = "WIDGETS_UPLOAD_SUCCESS";
